import {CategoryImageRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";

export class CategoryImageRestDtoModel implements CategoryImageRestDto {

    image_url: string;
    mime_type: string;

    constructor(image_url: string, mime_type: string) {
        this.image_url = image_url;
        this.mime_type = mime_type;
    }

    public static createWithDefaults(): CategoryImageRestDtoModel {
        return new this('', '');
    }
}
